// import { serviceApplicability, ServiceGroups, serviceMeta, userTypeLabel, userTypeToServiceGroup } from "@/config/serviceConfig";
import {
  serviceApplicability,
  serviceMeta,
  userTypeLabel,
} from "@/config/serviceConfig";

import { useUserContext } from "@/context/UserContext";
import { buttonPrimary } from "@/styles/buttons";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

type ServiceExplorerState = {
  selectedService?: string;
};

const DetailedServiceProfilePage = () => {
    const navigate = useNavigate();
    const { user } = useUserContext();
    console.log("User Payload:", JSON.stringify(user));
    const location = useLocation();
    const state = (location.state as ServiceExplorerState | null) ?? {};
    
    const effectiveUserType =
        (
            localStorage.getItem("authUserContext") ??
            user?.user_type ??
            "INDIVIDUAL"
        ).toUpperCase();

    const serviceGroupLabel =
        userTypeLabel[effectiveUserType];

    const applicableServices =
        serviceApplicability[effectiveUserType] ?? [];

    // Use URL parameter if valid, otherwise default to first applicable service
    const initialService =
    location.state?.selectedService && applicableServices.includes(location.state.selectedService)
        ? location.state.selectedService
        : applicableServices[0];

const [selectedShortname, setSelectedShortname] = useState(() => {
  return (
    state.selectedService &&
    applicableServices.includes(state.selectedService)
  )
    ? state.selectedService
    : applicableServices[0];
});

useEffect(() => {
  if (
    state.selectedService &&
    state.selectedService !== selectedShortname &&
    applicableServices.includes(state.selectedService)
  ) {
    setSelectedShortname(state.selectedService);
  }
}, [
  state.selectedService,
  applicableServices,
  selectedShortname,
]);

    // No services available for this user
    if (!selectedShortname) {
        return (
            <div className="p-8 text-center">
                No services are available for your account.
            </div>
        );
    }

const meta = selectedShortname
  ? serviceMeta[selectedShortname]
  : undefined;

    if (!meta) {
        return (
            <div className="p-8 text-center">
                Service configuration not found.
            </div>
        );
    }

    const ServiceDetailsComponent = meta.serviceDetails;

    const handleNewRequest = () => {
        if (!meta.requestRoute) return;

        navigate("/home/orders/new/true");
    };

    const handleBack = () => {
        navigate("/home");
    };

    const handleDashboardNavigation = () => {
        navigate("/home/orders");
    };
if (!meta) {
  return (
    <div className="p-8 text-center">
      Service configuration not found.
    </div>
  );
}

return (
  <div className="w-full mx-auto ">
    {/* Top Header + Services in Gradient Background */}
    {/* <div className="bg-gradient-to-r from-green-400 via-blue-500 to-purple-600 rounded-t-lg px-4 py-6"> */}
      <div
  className="rounded-t-lg px-4 py-4 bg-cover bg-center"
  style={{ backgroundImage: "url('assets/images/servicepagebg.jpg')" }}
>
      {/* Header Row */}

      {/* <div className="flex justify-between items-center mb-5"> */}
        <h2 className="text-lg text-white mb-2">{serviceGroupLabel}</h2>

        {/* <button
          onClick={handleBack}
          className="px-3 py-1 text-sm bg-white text-gray-800 rounded hover:bg-gray-100"
        >
          ← Back
        </button> */}
      {/* </div> */}

      {/* Services Row */}
<div className="flex justify-between items-center mb-5">
  {/* Services buttons */}
  <div className="flex flex-wrap gap-2">
    {applicableServices.map((svc) => {
      const svcMeta = serviceMeta[svc];
      return (
        <button
          key={svc}
          onClick={() => setSelectedShortname(svc)}
          className={`rounded-full px-4 py-2 transition ${
            svc === selectedShortname
              ? "bg-blue-600 text-white"
              : "bg-white text-gray-800 hover:bg-gray-200"
          }`}
        >
          {svcMeta.displayName}
        </button>
      );
    })}
  </div>
        <button
          onClick={handleDashboardNavigation}
          className="px-3 py-2 text-sm bg-white text-gray-800 rounded hover:bg-gray-100"
        >
          My Orders
        </button>
  </div>
</div>

<div className="flex items-center justify-between bg-blue-200 p-2">
  {meta.requestRoute && (
    <button
      className={buttonPrimary}
      onClick={handleNewRequest}
    >
      Place An Order
    </button>
  )}
  </div>

    {/* Service Details */}
    <div className="px-4 py-6 bg-gray-50">
      {ServiceDetailsComponent && <ServiceDetailsComponent />}
    </div>
  </div>
);
};

export default DetailedServiceProfilePage;